import { productsData } from "../../productsData"
import { Chart } from "../components/dashboard/Chart"
import { DashboardCard } from "../components/dashboard/DashboardCard"
import { BestSeller } from "../components/dashboard/BestSeller"
import { OrderRow } from "../components/global/OrderRow"
import { useContext, useState, useEffect } from "react"
import { OrdersContext } from "../../contexts/OrdersContext"
import "./adminDashboard.css"

export function AdminDashboard() {
    const [orders, setOrders] = useState(null)

    const ordersContextData = useContext(OrdersContext)
    const { state } = ordersContextData

    useEffect(() => {
        if (state) {
            setOrders(state)
        }
    }, [state])

    const cards = [
        { about: "order", text: "Today Orders", value: "120" },
        { about: "calendar", text: "This Month Orders", value: "890.45" },
        { about: "calendar", text: "This Month Sales", value: "1235" },
        { about: "money", text: "All Time Sales", value: "2050.45" },
    ]

    const bestSellers = [
        { product: productsData[12], revenue: 322, sales: 13 },
        { product: productsData[15], revenue: 596, sales: 20 },
        { product: productsData[13], revenue: 103, sales: 5 },
    ]

    return (
        <div className="dashboard">
            <h4>Dashboard</h4>

            <div className="d-flex flex-wrap justify-content-between cards-container mt-5">
                {
                    cards.map((e, i) => (
                        <DashboardCard
                            key={i}
                            about={e.about}
                            text={e.text}
                            value={e.value}
                        />
                    ))
                }
            </div>

            <div className="d-flex section2 mt-3 lg-row">
                <Chart />
                <div className="best-sellers border rounded-1 p-3 d-flex flex-column">
                    <div className="section-header pb-2">Best Sellers</div>

                    <div className="my-auto d-flex flex-column justify-content-center gap-4 h-100">
                        {
                            bestSellers.map((e, i) => (
                                <BestSeller
                                    key={i}
                                    product={e.product}
                                    revenue={e.revenue}
                                    sales={e.sales}
                                />
                            ))
                        }
                    </div>
                </div>
            </div>

            <div className="recent-orders rounded-1 p-3 mt-3 border">
                <div className="section-header pb-2">Recent Orders</div>

                <div className="table-wrapper">
                    <table className="orders-table mt-1 mb-3">
                        <tbody>
                            <tr className="table-header">
                                <td>Order ID</td>
                                <td>Date</td>
                                <td>Customer</td>
                                <td>Status</td>
                                <td className="text-end pe-5">Amount</td>
                            </tr>
                        </tbody>
                    </table>

                    {
                        orders && orders.map((e, i) => (
                            <OrderRow key={i} order={e} />
                        ))
                    }
                </div>
            </div>

        </div>
    )
}